import {
  gtcAddToCart
} from "gtcUtils";

/************************* Custom Complimantary products in cart drawer *************************/

sessionStorage.removeItem("upsellProducts");


// Mutationobserver to observe the cart drawer, is its open or not

let cartDrawerOpen = false;

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.target.hasAttribute("open")) {
      cartDrawerOpen = true;
    } else {
      cartDrawerOpen = false;
      document.body.style.setProperty("--upsell-animation-speed", "0.3s");
    }
  });
});

observer.observe(document.querySelector("cart-drawer"), {
  attributes: true,
  attributeFilter: ["open"],
  childList: false,
  subtree: false,
});


class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dom = {};
    this.dom.container = this.querySelector(".gtc-cart-upsell__container");
    this.dom.productContainer = this.querySelector(
      ".gtc-cart-upsell__products"
    );


    if (cartDrawerOpen) {
      // set css varianble --upsell-animation-speed to 0s
      document.body.style.setProperty("--upsell-animation-speed", "0s");
    }

    this.settings = {
      ...JSON.parse(this.getAttribute("settings")),
    };

    const tempData = this.getTempData("upsellProducts");

    if (tempData) {
      this.dom.productContainer.innerHTML = tempData;
    } else {
      this.observeElement();
    }

    if (this.dom.productContainer.children.length === 0) {
      this.dom.container.hidden = true;
    }

    this.addListeners();
  }

  disconnectedCallback() {
    this.removeListeners();
  }

  animateHeight = (element, from, to, duration) => {
    let start = null;
    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const value = (progress / duration) * (to - from) + from;
      element.style.height = `${ value }px`;
      if (progress < duration) {
        window.requestAnimationFrame(step);
      } else {
        if (to !== 0) {
          element.style.removeProperty("height");
        } else {
          element.style.height = `${ to }px`;
        }
      }
    };
    window.requestAnimationFrame(step);
  };

  hideContainer = (bool) => {
    const isMobile = !window.matchMedia("(min-width: 767px)").matches;
    if (bool) {
      if (isMobile) {
        this.animateHeight(this, this.offsetHeight, 0, 300);
      }
      this.dom.container.classList.remove("gtc-upsell-animate-out");

    } else {
      if (isMobile) {
        this.animateHeight(this, 0, this.scrollHeight, 300);
      }

      //This forces repaint
      void this.offsetHeight;
      this.dom.container.classList.add("gtc-upsell-animate-out");
    }
  };

  observeElement() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Change this threshold value as needed
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(async (entry) => {
        if (entry.boundingClientRect.right > 0) {
          if (this.settings.intent !== "manual") {
            await this.getUpsellProducts({ cart: null });
          } else if (
            this.settings.intent === "manual" &&
            this.dom.productContainer.children.length > 0
          ) {

            this.dom.container.hidden = false;
            this.hideContainer(false);
          }
          // Stop observing intersection of target
          this.observer.disconnect();
        }
      });
    }, options);

    this.observer.observe(this);
  }

  addListeners() {
    // if (this.settings.intent !== "manual") return;

    document.addEventListener("gtc:product:added", async (event) => {
      await this.getUpsellProducts({ cart: null });
    });
  }

  removeListeners() {
    if (this.observer) {
      this.observer.disconnect();
    }

    // if (this.settings.intent !== "manual") return;

    document.removeEventListener("gtc:product:added", async (event) => {
      await this.getUpsellProducts({ cart: null });
    });
  }

  compareArrays = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };

  getUpsellProducts = async ({ cart }) => {
    
    if (!this.dom.container || !this.dom.productContainer) return;
    const url = this.settings.url;
    const limit = Number(this.settings.limit);
    const urls = [];
    let productsArr = [];

    if (cart === null) {
      cart = await (await fetch(`${ Shopify.routes.root }cart.js`)).json();
    }

    const products_id = cart.items.map((x) => x.product_id);

    //If there is no change in the products, abort.
    if (this.compareArrays(this.settings.cartProductIdArray, products_id))
      return;

    //Save the products currently in cart.
    this.settings.cartProductIdArray = products_id;

    /**
     * Reversing the array, so the first product added complimentary products get shown first
     */

    products_id.reverse().forEach((id) => {
      urls.push(url.replace("[product_id]", id));
    });

    let productCount = 0;

    // Getting array of complementary products
    await Promise.all(
      urls.map((url) =>
        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            json.products.forEach((product) => {
              if (limit === 0 || productCount < limit) {
                productsArr.push(product);
                productCount++;
              } else {
                return;
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
      )
    );

    // Uniqify array of complementary products
    const uniqueProductsArr = Array.from(
      new Set(productsArr.map((a) => a.id))
    ).map((id) => {
      return productsArr.find((a) => a.id === id);
    });

    if (productsArr.length <= 0) {
      this.hideContainer(true);
      this.dom.container.hidden = true;
      return;
    }

    let upsellProductObjArray = [];

    // Getting html for array of complementary products
    await Promise.all(
      uniqueProductsArr.map((product) =>
        fetch(`/products/${ product.handle }?view=cart-upsell`)
          .then((data) => {
            return data.text();
          })
          .then((htmlText) => {
            const upsellProductObj = {};
            upsellProductObj.id = product.id;
            upsellProductObj.html = htmlText;
            upsellProductObjArray.push(upsellProductObj);
          })
      )
    );

    const uniqueProductsIdArr = uniqueProductsArr.map((product) => product.id);

    upsellProductObjArray.sort(function(a, b) {
      return (
        uniqueProductsIdArr.indexOf(a.id) - uniqueProductsIdArr.indexOf(b.id)
      );
    });

    let newProductsString = "";
    upsellProductObjArray.forEach((upsellProductObj) => {
      newProductsString += upsellProductObj.html;
    });

    this.dom.productContainer.innerHTML = null;
    this.dom.productContainer.insertAdjacentHTML(
      "beforeend",
      newProductsString
    );

    this.setTempData("upsellProducts", newProductsString);

    if (this.dom.container.hidden) {
      this.dom.container.hidden = false;
      this.hideContainer(false);
    }
  };

  // Method to set data in temporary storage
  setTempData(key, value) {
    sessionStorage.setItem(key, value);
  }

  // Method to get data from temporary storage
  getTempData(key) {
    return sessionStorage.getItem(key);
  }
}

if (!window.customElements.get("gtc-cart-upsell")) {
  customElements.define("gtc-cart-upsell", CartUpsell);
}



/************************* Custom Complimantary products in cart drawer *************************/


class UpsellAddToCart extends HTMLElement {

  constructor() {
    super();
    this.addToCart.bind(this);
  }

  connectedCallback() {
    this.settings = {
      variantId: this.getAttribute("variant-id"),
      quantity: this.getAttribute("quantity") || 1,
    };

    this.addEventListener("click", this.addToCart);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.addToCart);
  }

  addToCart = async () => {
    gtcAddToCart({ variantId: this.settings.variantId, quantity: this.settings.quantity });
  }
}


if (!window.customElements.get("gtc-upsell-item-add-to-cart")) {
  customElements.define("gtc-upsell-item-add-to-cart", UpsellAddToCart);
}


